export default {
  label: 'Campaign Name',
  placeholder: 'None',
};
